import React from 'react'
import { useDispatch } from 'react-redux'
import { Menu } from '@dsny/dsny-component-library/icons'
import { useTheme } from 'styled-components'
import SettingActions from 'reducers/Setting'
import { MenuButton } from './HamburguerMenu.styles'
import { useDesktopMediaQuery } from 'utils/hooks/useMediaQueries'

export default function HamburguerMenu({ onClick, className, style }) {
  const dispatch = useDispatch()
  const theme = useTheme()
  const isDesktop = useDesktopMediaQuery()

  const toggleSideNav = () => {
    dispatch(SettingActions.toggleSidebar())
    onClick?.()
  }

  if (isDesktop) return null

  return (
    <MenuButton
      type="button"
      className={`${className} focus:outline-none`}
      onClick={toggleSideNav}
      style={style}
    >
      <Menu width={18} height={18} color={theme.colors.neutralW90} />
    </MenuButton>
  )
}
